<template>
  <a-modal
          title="上传检测结果"
          okText="确定"
          cancelText="取消"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="受检单位名称" prop="checkerName">
            <a-ext-bold-a v-model="formState.checkerName"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所属监测环节" prop="pickLink">
            <a-ext-bold-a v-model="formState.pickLink"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="检测品种" prop="pickType">
            <a-ext-bold-a v-model="formState.pickType"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="检测数量" prop="checkCount">
            <a-ext-bold-a v-model="formState.checkCount"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="污染物信息" prop="badThings">
            <a-ext-bold-a v-model="formState.badThings"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="检测结果" prop="checkIsGood">
            <a-ext-local-dic-select :disabled="param.disabled||formState.checkIsGood==='不合格'" dic-key="MonitCheckResult" v-model="formState.checkIsGood"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="检测单上传" prop="listCheckFiles">
            <a-ext-muti-upload :disabled="param.disabled" :belong-id="param.id" belong-type="检测单" belong-small-type="检测单" v-model="formState.listCheckFiles"></a-ext-muti-upload>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="备注说明" prop="remark">
            <a-textarea
                    :disabled="param.disabled"
                    placeholder="请输入备注说明"
                    :auto-size="{ minRows: 2, maxRows: 6 }"
                    v-model="formState.remark"
            ></a-textarea>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtBoldA from '../../../components/AntDesignExt/All/AExtBoldA'
import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import AExtMutiUpload from '../../../components/AntDesignExt/All/AExtMutiUpload'
import {reportMonitCheck as saveApi,getMonitCheckReportInfo as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtBoldA,AExtLocalDicSelect,AExtMutiUpload,},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                checkerName:'',
                pickLink:'',
                pickType:'',
                checkCount:'',
                badThings:'',
                checkIsGood:'',
                checkFile:'',
                remark:'',
            },
            rules: {
                checkIsGood: FormRules.withName('检测结果').isRequired().create(),
                checkFile: FormRules.withName('上传附件').callback((value, field) => {
                    if (!value.name) {
                        return new Error('必须上传附件');
                    }
                }).create(),
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi({checkId:this.param.id,pickId:this.param.pickId}).then((result => {
                    this.formState = result.data.data;
                    this.formState={...this.param,...this.formState}
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
            //this.formState={...this.formState,...this.param}
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.formState.checkId=this.param.id;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("checkInfoModalClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>